// window doesn't exist during SSR (src/entry-server.jsx). SITE_URL is the
// same env var api/server.js already uses for absolute URLs in robots.txt /
// sitemap.xml, so canonical/OG/hreflang tags resolve to the real origin in a
// prerendered page instead of going blank.
export function currentOrigin() {
  if (typeof window !== 'undefined') return window.location.origin;
  if (typeof process !== 'undefined' && process.env.SITE_URL) {
    return process.env.SITE_URL;
  }
  return '';
}

// Scrivito.urlFor() returns a site-relative path in the browser, but an
// already-absolute URL during SSR (src/entry-server.jsx) - it has a real
// baseUrl there, from Scrivito.renderPage()'s siteId/origin context.
export function toAbsoluteUrl(urlOrPath, origin) {
  if (!urlOrPath) return urlOrPath;
  return /^https?:\/\//.test(urlOrPath) ? urlOrPath : `${origin}${urlOrPath}`;
}
